import { LoginForm } from '@/modules/auth/components/LoginForm'

export function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card p-8 w-full max-w-md">
        <LoginForm />
      </div>
    </div>
  )
}
